import { useMutation } from '@tanstack/react-query';
import { TenantsApi } from '@digiwedge/access-control-api-client';
import { createAccessControlConfiguration, createAccessControlQueryScope, useAccessControlContext, } from './AccessControlApiProvider.js';
export function useTenantsControllerCreateTenantMutation(options) {
    const accessControlContext = useAccessControlContext();
    const accessControlScope = createAccessControlQueryScope(accessControlContext);
    const accessControlConfig = createAccessControlConfiguration(accessControlContext);
    return useMutation({
        mutationKey: ['tenantsControllerCreateTenant', accessControlScope],
        mutationFn: async (args) => {
            const api = new TenantsApi(accessControlConfig);
            return api.tenantsControllerCreateTenant(...args);
        },
        ...options,
    });
}
//# sourceMappingURL=useTenantsControllerCreateTenantMutation.js.map